import { CardHeader, Heading, Text } from '@chakra-ui/react'

import { useAddPlayerContext } from '@contexts/AddPlayerContext'

import { PlayerDetailLink } from './PlayerDetailLink'

export function PlayerCardHeader() {
    const { newPlayer, isFrontFakePlayer } = useAddPlayerContext()

    return (
        <CardHeader>
            <Heading size="sm" fontStyle="italic">
                {newPlayer.surname}
            </Heading>
            {newPlayer?.id && !isFrontFakePlayer && (
                <Text fontSize="xs" fontWeight="bold" color="GrayText">
                    ID: {newPlayer.id}
                </Text>
            )}
            <PlayerDetailLink />
        </CardHeader>
    )
}
